import { useCallback } from "react";
import { HoopsApi, useAPIAction } from "melco-shared-logic";

export const useDeleteHoop = (hoopIdToDelete?: string) => {
    const [deleteHoop] = useAPIAction(
        HoopsApi,
        async (api) => {

            const data = await api.hoopsDelete({
                "id": hoopIdToDelete ?? ""
            });

            return {
                successMessages: [{ message: "default" },],
                data,
            };
        },
        {
            translationPrefix: "managehoops.actions.delete",

        }
    );

    return useCallback(
        async () => {

            await deleteHoop();


            return { success: true };
        },
        [deleteHoop]
    );
};
